'use strict';

/** @type {object} 操作URLが設定されているformタグ(form.ds-form)におけるdata-*属性名 */
const OPERATION_URL = {
    /** @type {string} 再計算に対応するURL */
    UPDATE: 'url-recalculate',
    /** @type {string} 商品削除に対応するURL */
    DELETE: 'url-delete',
    /** @type {string} チェックアウト処理画面遷移に対応するURL */
    TRANSITION: 'url-transition',
};
const clicklock = require('app_common/components/clicklock');
const {showError, hideError} = require('app_common/client/clientErrorUtils');
const {encodeHtml} = require('sswd_base/util/XStringUtils');

/**
 * Ajaxサービス呼び出し
 *
 * @param {string} operationUrl - 送信先URL
 * @param {string} $form - フォーム
 * @returns {Promise<undefined>}
 */
async function submit(operationUrl, $form) {
    // クリックイベントをロックする
    if (!clicklock.lock()) {
        // ロックできなかった場合は何もしない
        return;
    }
    try {
        // スピナーを開始する
        $.spinner().start();
        // 表示・非表示の状態に関わらず、一旦エラーメッセージを隠す
        hideError();

        const formData = new FormData($form[0]);
        const url = $form.data(operationUrl);
        const postForm = require('sswd_base/components/XPostForm');
        const response = await postForm(url, formData);
        // レスポンスデータにredirectUrlが含まれる場合
        if (response.redirectUrl) {
            // redirectUrlに移動
            window.location.href = response.redirectUrl;
            return;
        }
        // レスポンスデータにerror(エラーメッセージの配列)が含まれる場合
        if (Array.isArray(response.error)) {
            // エラーメッセージを表示
            showError(response.error);
            return;
        }
        // レスポンスデータにredirectUrlもerrorも含まれない場合
        // エラーを投げる
        throw new Error();
    } catch (e) {
        // エラーメッセージを表示
        showError(['システムエラーが発生しました。']);
    } finally {
        // スピナーを停止する
        $.spinner().stop();
        // クリックイベントをアンロックする
        clicklock.unlock();
    }
}

/**
 * カート内の商品情報を設定したjQueryフォームオブジェクトを返す。
 *
 * @param {object} postDataObj - productLineItemを表すオブジェクト
 * - productId: 商品ID(文字列)
 * - deliveryAddressId: お届け先住所ID(文字列)
 * - quantity: 数量(数値)
 * ```js
 * {
 *      productId: '12567',
 *      deliveryAddressId: '10000003',
 *      quantity: 2,
 * }
 * ```
 * @returns {jQuey<Element>} $form - jQueryフォームオブジェクト
 */
function getLineItemFormInfo(postDataObj) {
    const $form = $('.ds-form');
    const productId = postDataObj.productId;
    const deliveryAddressId = postDataObj.deliveryAddressId;
    const quantity = postDataObj.quantity;
    $('input[type="hidden"][data-formid="productId"]', $form).val(productId);
    $('input[type="hidden"][data-formid="deliveryAddressId"]', $form).val(deliveryAddressId);
    $('input[type="hidden"][data-formid="quantity"]', $form).val(quantity);
    return $form;
}

/**
 * カートの選択状況を取得しformとして返す
 *
 * @param {*} postDataObj - コントローラー送信用データオブジェクト
 * @returns {object} $form - フォーム
 */
async function getShoppingBagFormInfo(postDataObj) {
    const $form = $('.shopping-bag-form');
    $('input[type="hidden"][data-formid="isBuyShopBag"]', $form).val(postDataObj.isBuyShopBag);
    $('input[type="hidden"][data-formid="isDontBuyShopBag"]', $form).val(
        postDataObj.isDontBuyShopBag
    );
    return $form;
}

/**
 * 商品削除処理を実行する。
 *
 * @param {string} postDataObj - コントローラー送信用データオブジェクト
 * @returns {Promise<undefined>}
 */
async function deleteItem(postDataObj) {
    const $form = getLineItemFormInfo(postDataObj);
    await submit(OPERATION_URL.DELETE, $form);
}

/**
 * 商品数量変更処理を実行する。
 *
 * @param {string} postDataObj - コントローラー送信用データオブジェクト
 * @returns {Promise<undefined>}
 */
async function updateQuantity(postDataObj) {
    const $form = getLineItemFormInfo(postDataObj);
    await submit(OPERATION_URL.UPDATE, $form);
}

/**
 * チェックアウト画面遷移を実行する。
 *
 * @param {*} postDataObj - コントローラー送信用データオブジェクト
 */
async function transitionCheckOut(postDataObj) {
    const $form = await getShoppingBagFormInfo(postDataObj);
    await submit(OPERATION_URL.TRANSITION, $form);
}

/**
 * 商品情報をPOST用に加工する
 *
 * @param {jQuery<Element>} currentTarget - イベントに対応するjQuery要素オブジェクト
 * @param {number} quantity - 商品の数量
 * @returns {object} productLineItemを表すオブジェクト
 * - productId: 商品ID(文字列)
 * - deliveryAddressId: お届け先住所ID(文字列)
 * - quantity: 数量(数値)
 * ```js
 * {
 *      productId: '12567',
 *      deliveryAddressId: '10000003',
 *      quantity: 2,
 * }
 * ```
 */
function getPostDataObj(currentTarget, quantity) {
    // 対象の商品を特定する商品IDとお届け先IDを取得する
    const productId = currentTarget.data('product-id');
    const addressId = currentTarget.data('address-id');

    const productLineItem = {
        productId: productId ? productId + '' : '',
        deliveryAddressId: addressId ? addressId + '' : '',
        quantity: parseInt(quantity, 10),
    };

    return productLineItem;
}

/**
 * モーダルの内容を置き換える
 *
 * モーダル表示用データ
 *      productName - 商品名
 *      priceLabel - 税込み価格、税抜き価格
 *      productID - 商品ID
 *      addressid - お届け先ID
 *
 * @param {object} modalValues - モーダル表示用データ
 */
function confirmDelete(modalValues) {
    const $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    const $productToRemoveSpan = $('.product-to-remove');
    const $priceToRemoveSpan = $('.price-to-remove');

    // 商品名と商品価格を表示する
    $productToRemoveSpan.empty().text(modalValues.productName);
    $priceToRemoveSpan.empty().html(`<li>${encodeHtml(modalValues.priceLabel)}</li>`);

    // 次処理用にセットする
    $deleteConfirmBtn.data('product-id', modalValues.productId);
    $deleteConfirmBtn.data('address-id', modalValues.addressId);
}

/**
 * モーダル表示用データを取得する。
 *
 * @param {object} $displayData - コントローラー送信用データオブジェクト
 * @returns {object} 取得した値
 */
function getModalValues($displayData) {
    // モーダル画面表示用
    const productName = $displayData.data('product-name');
    const priceLabel = $displayData.data('pricelabel');
    // 次処理用
    const productId = $displayData.data('product-id');
    const addressId = $displayData.data('address-id');

    return {
        productName: productName,
        priceLabel: priceLabel,
        productId: productId,
        addressId: addressId,
    };
}

/**
 * 準備処理
 */
function ready() {
    // 表示制御：数量変更時の再計算ボタン
    $('.spinner-area input, .spinnerInput').on('input click', function () {
        let idNumber;

        if ($(this).hasClass('spinnerInput')) {
            // テキストエリア
            idNumber = this.name.replace('quantity_', '');
            // 注文可否情報を保存する
            const orderAbleFlg = $('#recalculateButton_' + idNumber).data('orderable');
            // 現在の数量を保存する
            const originalValue = $(this).data('originalValue');
            if (!originalValue) {
                $(this).data('originalValue', this.value);
            } else if (originalValue !== this.value && orderAbleFlg) {
                // 値が変わればボタンを活性化
                $('#recalculateButton_' + idNumber).removeClass('disabled', false);
            }
        } else {
            // スピナーエリア
            const target = $(this).data('target');
            idNumber = target.replace('.counter-', '');
            // 注文可否情報を保存する
            const orderAbleFlg = $('#recalculateButton_' + idNumber).data('orderable');
            if (orderAbleFlg) {
                $('#recalculateButton_' + idNumber).removeClass('disabled', false);
            }
        }
    });

    // 表示制御：数量エリアフォーカスアウト時に、
    $('.spinner-area input, .spinnerInput').on('blur', function () {
        // 入力が空白や未入力の場合、値を1に設定
        if ($(this).val().trim() === '') {
            $(this).val(1);
        }
    });

    // 表示制御：手提げ袋選択画面遷移ボタン 初期表示は表示しない
    if (
        !$('input[type=radio][name=bagPurchase]').is(':checked') ||
        $('#isDontBuyShopBag').is(':checked')
    ) {
        $('#changeBagPurchase').attr('hidden', 'true');
    } else {
        $('#changeBagPurchase').removeAttr('hidden');
    }

    // 表示制御：手提げ袋選択画面遷移ボタン
    $('input[type=radio][name=bagPurchase]').on('change', function () {
        if (this.id === 'isBuyShopBag') {
            $('#changeBagPurchase').removeAttr('hidden');
        } else if (this.id === 'isDontBuyShopBag') {
            $('#changeBagPurchase').attr('hidden', 'true');
        }
    });

    $('#isBuyShopBag').on('click', (e) => {
        e.preventDefault();
        window.location.href = $('input[type="hidden"][data-formid="isBuyShopBag"]').data('url');
    });

    // 「削除」アイコンがクリックされた場合の処理
    $('.remove-product').on('click', function (e) {
        e.preventDefault();

        // 削除ボタンから商品情報を取得する
        // モーダル画面表示用
        const $deleteIcon = $(e.currentTarget);
        const modalValues = getModalValues($deleteIcon);

        // モーダルが表示される直前に内容を表示する
        $('#deleteProductModal').on('show.bs.modal', function () {
            confirmDelete(modalValues);
        });
    });

    // モーダルの「削除する」ボタンが押された場合の処理
    $('.cart-delete-confirmation-btn').on('click', async (e) => {
        e.preventDefault();

        const $modalDeleteButton = $(e.currentTarget);

        // post用にオブジェクトを生成する
        // 対象の商品を特定する商品IDとお届け先IDも設定する
        const postDataObj = getPostDataObj($modalDeleteButton, 0);

        // 削除処理を呼び出す
        await deleteItem(postDataObj);

        $('#deleteProductModal').modal('hide');
    });

    // 「再計算」ボタンがクリックされたときの処理
    $('.recalculate').on('click', async (e) => {
        e.preventDefault();

        const $recalculateButton = $(e.currentTarget);
        // 現在の数量を取得（ユーザが入力した数量）
        const quantity = $recalculateButton.closest('.quantityx').find('.form-control').val();

        if (quantity === '0') {
            const modalValues = getModalValues($recalculateButton);

            // モーダルが表示される直前に内容を表示する
            $('#deleteProductModal').on('show.bs.modal', function () {
                confirmDelete(modalValues);
            });
            // モーダルが閉じられる際のイベント
            $('#deleteProductModal').on('hidden.bs.modal', function () {
                // モーダル設定を無効にする
                $recalculateButton.removeAttr('data-toggle');
            });

            // モーダルのデータ切り替え属性を有効にする
            $recalculateButton.attr('data-toggle', 'modal');
        } else {
            // post用にオブジェクトを生成する
            // 対象の商品を特定する商品IDとお届け先IDも設定する
            const postDataObj = getPostDataObj($recalculateButton, quantity);

            await updateQuantity(postDataObj);

            // データ切り替え属性を再度有効にする
            $recalculateButton.removeAttr('data-toggle');
        }
        return false;
    });

    // SPにて数量変更されたときの処理
    $('.custom-select').on('change', async (e) => {
        e.preventDefault();

        const $customSelect = $(e.target);
        // 現在の数量を取得（ユーザが選択した数量）
        const quantity = $customSelect.val();

        if (quantity === '0') {
            const modalValues = getModalValues($customSelect);

            // モーダルが表示される直前に内容を表示する
            $('#deleteProductModal').on('show.bs.modal', function () {
                confirmDelete(modalValues);
            });
            // モーダルが閉じられる際のイベント
            $('#deleteProductModal').on('hidden.bs.modal', function () {
                // モーダル設定を無効にする
                $customSelect.removeAttr('data-toggle');
            });

            // モーダルのデータ切り替え属性を有効にする
            $customSelect.attr('data-toggle', 'modal');
        } else {
            // post用にオブジェクトを生成する
            // 対象の商品を特定する商品IDとお届け先IDも設定する
            const postDataObj = getPostDataObj($customSelect, quantity);

            await updateQuantity(postDataObj);

            // データ切り替え属性を再度有効にする
            $customSelect.removeAttr('data-toggle');
        }
        return false;
    });

    // 「ご注文はこちら」ボタンがクリックされたときの処理
    $('.checkout-btn').on('click', async (e) => {
        e.preventDefault();

        const isBuyShopBagElement = document.getElementById('isBuyShopBag');
        const isDontBuyShopBagElement = document.getElementById('isDontBuyShopBag');
        const errMessageElement = document.getElementById('shopbag-error-message');

        // 2. 手提げ袋の必要状況確認・更新
        // 2.1 手提げ袋購入する・しないラジオボタン選択状態チェック
        if (!isBuyShopBagElement.checked && !isDontBuyShopBagElement.checked) {
            const errMessage = errMessageElement.textContent;
            showError([errMessage]);
        } else {
            // post用にオブジェクトを生成する
            const postDataObj = {
                isBuyShopBag: isBuyShopBagElement.checked,
                isDontBuyShopBag: isDontBuyShopBagElement.checked,
            };
            await transitionCheckOut(postDataObj);
        }
    });
}

module.exports = {
    ready,
};
